//Dependencias
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Componentes
import BannerFichas from '../../components/BannerFichas/BannerFichas';
import Navbar from '../../components/Navbar/Navbar';
import SessionBar from '../../components/SessionBar/SessionBar';
import Footer from '../../components/Footer/Footer';
import DetalleJuegoHis from '../../components/DetalleJuego/DetalleJuegoHis/DetalleJuegoHis';

//Funciones
import { fetchUserData } from '../../utils/api';

const Historial = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    fetchUserData(navigate, setUserData);
  }, [navigate]);

  return (
    <div className="flex flex-col min-h-screen">
      <BannerFichas />
      <div className="bg-gradient-to-b from-slate-950 to-violet-950 flex-grow">
        <Navbar />
        {userData && <SessionBar />}
        <DetalleJuegoHis />
      </div>
      <Footer />
    </div>
  );
};

export default Historial;
